import { render, staticRenderFns } from "./System.Detail.vue?vue&type=template&id=79b7e62a&"
import script from "./System.Detail.vue?vue&type=script&lang=js&"
export * from "./System.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports